import { Component, Input, OnInit } from '@angular/core';
import { ProductSummary } from '@usf/product-types';
import { getFirstImageURL } from '../../utils/product-images.util';
import { ImageVariantEnum } from '../../models/image-variant.enum';

@Component({
  selector: 'app-product-detail-seller-image',
  templateUrl: './product-detail-seller-image.component.html',
  styleUrls: ['./product-detail-seller-image.component.scss'],
})
export class ProductDetailSellerImageComponent implements OnInit {
  @Input() product: ProductSummary;
  mainImageURL: string;

  constructor() {}

  ngOnInit() {
    this.mainImageURL = getFirstImageURL(this.product, ImageVariantEnum.XLarge);
  }
}
